export const normalizeVersion = (version: string) => {
    if (version.match(/^\d+\.\d+\.\d+(\.\d+)*$/)) {
        const v = version.split('.')
        return `${v[0]}.${v[1]}.${v[2]}`
    } else {
        return undefined
    }
}
